import { observer } from 'mobx-react-lite'
import React, { useRef } from 'react'
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useRouter } from 'expo-router'
import { translate } from '../../i18n'

import { useStore } from '../../models'
import { DS } from '../../design-system'

export const WebViewComponent = observer(({ url }: { url: string }) => {
  const router = useRouter()

  const webview = useRef(null)
  const store = useStore()

  const goToHome = () => {
    if (store.communication.channel?.channelName) {
      router.navigate('/game')
    } else if (router.canGoBack()) {
      router.back()
      return
    }
    router.navigate('/(root)/(tabs)')
  }

  return (
    <SafeAreaView style={styles.webview}>
      <View style={styles.headerWrapper}>
        <TouchableOpacity onPress={goToHome} style={styles.headerBackButtonContainer}>
          <Image
            source={require('../../../assets/menu/left-arrow.png')}
            style={[
              styles.headerBackButton
              // lastPage === HomeRoutes.manageMembership && { tintColor: DS.palette['Global/White'] }
            ]}
          />
          <DS.Icon name="Suite--Spade" color="Brand/Purple" size={backButtonSize - 4} />
          <DS.Text variant="Body Large/Regular">{` ${translate('common.app')}`}</DS.Text>
        </TouchableOpacity>
      </View>
      <iframe
        title="iframe"
        ref={webview}
        src={url}
        style={{
          height: '100%',
          width: '100%'
        }}
      />
    </SafeAreaView>
  )
})

const backButtonSize = DS.spacing[20]

const styles = StyleSheet.create({
  headerWrapper: {
    flexDirection: 'row',
    height: 2 * backButtonSize,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: DS.spacing[6]
  },
  headerBackButton: {
    width: backButtonSize,
    height: backButtonSize,
    tintColor: '#121212',
    opacity: 0.8,
    zIndex: 10
  },
  headerBackButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1,
    padding: DS.spacing[6]
  },
  webview: {
    flex: 1
  },
  browserButton: {
    paddingVertical: DS.spacing[6]
  }
})
